var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/common/constants/constants.ts
import { omit } from "lodash";
var NOT_APPLICABLE_HSA_ONLY = "not_applicable_hsa_only";
var ANALYTICS = {
  categories: {
    USAGE_REPORT: "Usage Report",
    INVOICES: "Invoices",
    REPORTS: "reports"
  }
};
var DAYFORCE_DRIVER = "dayforce_rest_hr";
var TYPING_DEBOUNCE_INTERVAL = 250;
var STARTED = "started";
var SUBMITTED_FOR_PREAPPROVAL = "submitted_for_preapproval";
var PREAPPROVAL_MORE_INFORMATION_NEEDED = "preapproval_more_information_needed";
var PREAPPROVED = "preapproved";
var PREAPPROVAL_REJECTED = "preapproval_rejected";
var MORE_INFORMATION_NEEDED = "more_information_needed";
var PENDING_EXTERNAL_REVIEW = "pending_external_review";
var SUBMITTED = "submitted";
var APPROVED = "approved";
var REJECTED = "rejected";
var CANCELLED = "cancelled";
var PAID = "paid";
var RESET = "reset";
var UPDATE = "update";
var VIEW_ALL = "VIEW_ALL";
var CLAIM_STATUS_TRANSLATIONS = {
  [STARTED]: "STARTED",
  [SUBMITTED_FOR_PREAPPROVAL]: "SUBMITTED_FOR_PREAPPROVAL",
  [PREAPPROVAL_MORE_INFORMATION_NEEDED]: "PREAPPROVAL_MORE_INFORMATION_NEEDED",
  [PREAPPROVED]: "PREAPPROVED",
  [PREAPPROVAL_REJECTED]: "PREAPPROVAL_REJECTED",
  [MORE_INFORMATION_NEEDED]: "MORE_INFORMATION_NEEDED",
  [PENDING_EXTERNAL_REVIEW]: "PENDING_EXTERNAL_REVIEW",
  [SUBMITTED]: "SUBMITTED",
  [APPROVED]: "APPROVED",
  [REJECTED]: "REJECTED",
  [CANCELLED]: "CANCELLED",
  [PAID]: "PAID"
};
var FRONTEND_CLAIM_STATUS_TYPES = [
  SUBMITTED,
  APPROVED,
  REJECTED,
  CANCELLED,
  PAID,
  MORE_INFORMATION_NEEDED
];
var EMPLOYER_STATUSES = {
  TERMINATED: "terminated",
  SUSPENDED: "suspended",
  READY: "ready",
  DRAFT: "draft",
  ACTIVE: "active",
  PUBLISHED: "published"
};
var EMPLOYER_STATUS_TYPE_MAP = {
  active: "ACTIVE",
  suspended: "SUSPENDED",
  ready: "READY",
  draft: "DRAFT"
};
var CLAIM_STATUS_TYPE_FILTER_MAP = omit(CLAIM_STATUS_TRANSLATIONS, [
  "started",
  "submitted_for_preapproval",
  "preapproval_more_information_needed",
  "preapproved",
  "preapproval_rejected"
]);
var ASCENDING = "asc";
var DESCENDING = "des";
var DEFAULT_TIME_ZONE = "America/Toronto";
var ALBERTA = "Alberta";
var BRITISH_COLUMBIA = "British Columbia";
var MANITOBA = "Manitoba";
var NEW_BRUNSWICK = "New Brunswick";
var NEWFOUNDLAND_LABRADOR = "Newfoundland and Labrador";
var NOVA_SCOTIA = "Nova Scotia";
var ONTARIO = "Ontario";
var PRINCE_EDWARD_ISLAND = "Prince Edward Island";
var QUEBEC = "Quebec";
var SASKATCHEWAN = "Saskatchewan";
var NORTHWEST_TERRITORIES = "Northwest Territories";
var NUNAVUT = "Nunavut";
var YUKON = "Yukon";
var YUKON_TERRITORIES = "Yukon Territories";
var ALABAMA = "Alabama";
var ALASKA = "Alaska";
var AMERICAN_SAMOA = "American Samoa";
var ARIZONA = "Arizona";
var ARKANSAS = "Arkansas";
var CALIFORNIA = "California";
var COLORADO = "Colorado";
var CONNECTICUT = "Connecticut";
var DELAWARE = "Delaware";
var DISTRICT_OF_COLUMBIA = "District of Columbia";
var FLORIDA = "Florida";
var GEORGIA = "Georgia";
var GUAM = "Guam";
var HAWAII = "Hawaii";
var IDAHO = "Idaho";
var ILLINOIS = "Illinois";
var INDIANA = "Indiana";
var IOWA = "Iowa";
var KANSAS = "Kansas";
var KENTUCKY = "Kentucky";
var LOUISIANA = "Louisiana";
var MAINE = "Maine";
var MARYLAND = "Maryland";
var MASSACHUSETTS = "Massachusetts";
var MICHIGAN = "Michigan";
var MINNESOTA = "Minnesota";
var MISSISSIPPI = "Mississippi";
var MISSOURI = "Missouri";
var MONTANA = "Montana";
var NEBRASKA = "Nebraska";
var NEVADA = "Nevada";
var NEW_HAMPSHIRE = "New Hampshire";
var NEW_JERSEY = "New Jersey";
var NEW_MEXICO = "New Mexico";
var NEW_YORK = "New York";
var NORTH_CAROLINA = "North Carolina";
var NORTH_DAKOTA = "North Dakota";
var OHIO = "Ohio";
var OKLAHOMA = "Oklahoma";
var OREGON = "Oregon";
var PENNSYLVANIA = "Pennsylvania";
var PUERTO_RICO = "Puerto Rico";
var RHODE_ISLAND = "Rhode Island";
var SOUTH_CAROLINA = "South Carolina";
var SOUTH_DAKOTA = "South Dakota";
var TENNESSEE = "Tennessee";
var TEXAS = "Texas";
var US_VIRGIN_ISLANDS = "US Virgin Islands";
var UTAH = "Utah";
var VERMONT = "Vermont";
var VIRGINIA = "Virginia";
var WASHINGTON = "Washington";
var WEST_VIRGINIA = "West Virginia";
var WISCONSIN = "Wisconsin";
var WYOMING = "Wyoming";
var AB = "AB";
var BC = "BC";
var MB = "MB";
var NB = "NB";
var NL = "NL";
var NS = "NS";
var NT = "NT";
var NU = "NU";
var ON = "ON";
var PE = "PE";
var QC = "QC";
var SK = "SK";
var YT = "YT";
var AL = "AL";
var AK = "AK";
var AS = "AS";
var AZ = "AZ";
var AR = "AR";
var CA = "CA";
var CO = "CO";
var CT = "CT";
var DE = "DE";
var DC = "DC";
var FL = "FL";
var GA = "GA";
var GU = "GU";
var HI = "HI";
var ID = "ID";
var IL = "IL";
var IN = "IN";
var IA = "IA";
var KS = "KS";
var KY = "KY";
var LA = "LA";
var ME = "ME";
var MD = "MD";
var MA = "MA";
var MI = "MI";
var MN = "MN";
var MS = "MS";
var MO = "MO";
var MT = "MT";
var NE = "NE";
var NV = "NV";
var NH = "NH";
var NJ = "NJ";
var NM = "NM";
var NY = "NY";
var NC = "NC";
var ND = "ND";
var OH = "OH";
var OK = "OK";
var OR = "OR";
var PA = "PA";
var PR = "PR";
var RI = "RI";
var SC = "SC";
var SD = "SD";
var TN = "TN";
var TX = "TX";
var UT = "UT";
var VI = "VI";
var VT = "VT";
var VA = "VA";
var WA = "WA";
var WV = "WV";
var WI = "WI";
var WY = "WY";
var provinceStateShortToLong = {
  [AB]: ALBERTA,
  [BC]: BRITISH_COLUMBIA,
  [MB]: MANITOBA,
  [NB]: NEW_BRUNSWICK,
  [NL]: NEWFOUNDLAND_LABRADOR,
  [NS]: NOVA_SCOTIA,
  [NT]: NORTHWEST_TERRITORIES,
  [NU]: NUNAVUT,
  [ON]: ONTARIO,
  [PE]: PRINCE_EDWARD_ISLAND,
  [QC]: QUEBEC,
  [SK]: SASKATCHEWAN,
  [YT]: YUKON,
  [AL]: ALABAMA,
  [AK]: ALASKA,
  [AS]: AMERICAN_SAMOA,
  [AZ]: ARIZONA,
  [AR]: ARKANSAS,
  [CA]: CALIFORNIA,
  [CO]: COLORADO,
  [CT]: CONNECTICUT,
  [DE]: DELAWARE,
  [DC]: DISTRICT_OF_COLUMBIA,
  [FL]: FLORIDA,
  [GA]: GEORGIA,
  [GU]: GUAM,
  [HI]: HAWAII,
  [ID]: IDAHO,
  [IL]: ILLINOIS,
  [IN]: INDIANA,
  [IA]: IOWA,
  [KS]: KANSAS,
  [KY]: KENTUCKY,
  [LA]: LOUISIANA,
  [ME]: MAINE,
  [MD]: MARYLAND,
  [MA]: MASSACHUSETTS,
  [MI]: MICHIGAN,
  [MN]: MINNESOTA,
  [MS]: MISSISSIPPI,
  [MO]: MISSOURI,
  [MT]: MONTANA,
  [NE]: NEBRASKA,
  [NV]: NEVADA,
  [NH]: NEW_HAMPSHIRE,
  [NJ]: NEW_JERSEY,
  [NM]: NEW_MEXICO,
  [NY]: NEW_YORK,
  [NC]: NORTH_CAROLINA,
  [ND]: NORTH_DAKOTA,
  [OH]: OHIO,
  [OK]: OKLAHOMA,
  [OR]: OREGON,
  [PA]: PENNSYLVANIA,
  [PR]: PUERTO_RICO,
  [RI]: RHODE_ISLAND,
  [SC]: SOUTH_CAROLINA,
  [SD]: SOUTH_DAKOTA,
  [TN]: TENNESSEE,
  [TX]: TEXAS,
  [UT]: UTAH,
  [VI]: US_VIRGIN_ISLANDS,
  [VT]: VERMONT,
  [VA]: VIRGINIA,
  [WA]: WASHINGTON,
  [WV]: WEST_VIRGINIA,
  [WI]: WISCONSIN,
  [WY]: WYOMING
};
var PROVINCE_CODES = {
  AB,
  BC,
  MB,
  NB,
  NL,
  NS,
  NT,
  NU,
  ON,
  PE,
  QC,
  SK,
  YT
};
var CANADA = "CA";
var UNITED_STATES = "US";
var IRELAND = "IE";
var US = UNITED_STATES;
var COUNTRY_OPTIONS = [
  { value: CANADA, text: "Canada", flag: "ca" },
  {
    value: UNITED_STATES,
    text: "United States of America",
    flag: "us"
  },
  {
    value: IRELAND,
    text: "Ireland",
    flag: "ie"
  }
];
var PROVINCE_STATE_OPTIONS = {
  [CANADA]: [
    { value: AB, text: ALBERTA },
    { value: BC, text: BRITISH_COLUMBIA },
    { value: MB, text: MANITOBA },
    { value: NB, text: NEW_BRUNSWICK },
    { value: NL, text: NEWFOUNDLAND_LABRADOR },
    { value: NS, text: NOVA_SCOTIA },
    { value: NT, text: NORTHWEST_TERRITORIES },
    { value: NU, text: NUNAVUT },
    { value: ON, text: ONTARIO },
    { value: PE, text: PRINCE_EDWARD_ISLAND },
    { value: QC, text: QUEBEC },
    { value: SK, text: SASKATCHEWAN },
    { value: YT, text: YUKON }
  ],
  [UNITED_STATES]: [
    { value: AL, text: ALABAMA },
    { value: AK, text: ALASKA },
    { value: AZ, text: ARIZONA },
    { value: AR, text: ARKANSAS },
    { value: AS, text: AMERICAN_SAMOA },
    { value: CA, text: CALIFORNIA },
    { value: CO, text: COLORADO },
    { value: CT, text: CONNECTICUT },
    { value: DE, text: DELAWARE },
    { value: DC, text: DISTRICT_OF_COLUMBIA },
    { value: FL, text: FLORIDA },
    { value: GA, text: GEORGIA },
    { value: GU, text: GUAM },
    { value: HI, text: HAWAII },
    { value: ID, text: IDAHO },
    { value: IL, text: ILLINOIS },
    { value: IN, text: INDIANA },
    { value: IA, text: IOWA },
    { value: KS, text: KANSAS },
    { value: KY, text: KENTUCKY },
    { value: LA, text: LOUISIANA },
    { value: ME, text: MAINE },
    { value: MD, text: MARYLAND },
    { value: MA, text: MASSACHUSETTS },
    { value: MI, text: MICHIGAN },
    { value: MN, text: MINNESOTA },
    { value: MS, text: MISSISSIPPI },
    { value: MO, text: MISSOURI },
    { value: MT, text: MONTANA },
    { value: NE, text: NEBRASKA },
    { value: NV, text: NEVADA },
    { value: NH, text: NEW_HAMPSHIRE },
    { value: NJ, text: NEW_JERSEY },
    { value: NM, text: NEW_MEXICO },
    { value: NY, text: NEW_YORK },
    { value: NC, text: NORTH_CAROLINA },
    { value: ND, text: NORTH_DAKOTA },
    { value: OH, text: OHIO },
    { value: OK, text: OKLAHOMA },
    { value: OR, text: OREGON },
    { value: PA, text: PENNSYLVANIA },
    { value: PR, text: PUERTO_RICO },
    { value: RI, text: RHODE_ISLAND },
    { value: SC, text: SOUTH_CAROLINA },
    { value: SD, text: SOUTH_DAKOTA },
    { value: TN, text: TENNESSEE },
    { value: TX, text: TEXAS },
    { value: UT, text: UTAH },
    { value: VI, text: US_VIRGIN_ISLANDS },
    { value: VT, text: VERMONT },
    { value: VA, text: VIRGINIA },
    { value: WA, text: WASHINGTON },
    { value: WV, text: WEST_VIRGINIA },
    { value: WI, text: WISCONSIN },
    { value: WY, text: WYOMING }
  ]
};
var COUNTRY_TO_PROVINCE = {
  [CANADA]: [
    ALBERTA,
    BRITISH_COLUMBIA,
    MANITOBA,
    NEW_BRUNSWICK,
    NEWFOUNDLAND_LABRADOR,
    NOVA_SCOTIA,
    NORTHWEST_TERRITORIES,
    NUNAVUT,
    ONTARIO,
    PRINCE_EDWARD_ISLAND,
    QUEBEC,
    SASKATCHEWAN,
    YUKON_TERRITORIES
  ],
  [UNITED_STATES]: [
    ALABAMA,
    ALASKA,
    AMERICAN_SAMOA,
    ARIZONA,
    ARKANSAS,
    CALIFORNIA,
    COLORADO,
    CONNECTICUT,
    DELAWARE,
    DISTRICT_OF_COLUMBIA,
    FLORIDA,
    GEORGIA,
    GUAM,
    HAWAII,
    IDAHO,
    ILLINOIS,
    INDIANA,
    IOWA,
    KANSAS,
    KENTUCKY,
    LOUISIANA,
    MAINE,
    MARYLAND,
    MASSACHUSETTS,
    MICHIGAN,
    MINNESOTA,
    MISSISSIPPI,
    MISSOURI,
    MONTANA,
    NEBRASKA,
    NEVADA,
    NEW_HAMPSHIRE,
    NEW_JERSEY,
    NEW_MEXICO,
    NEW_YORK,
    NORTH_CAROLINA,
    NORTH_DAKOTA,
    OHIO,
    OKLAHOMA,
    OREGON,
    PENNSYLVANIA,
    PUERTO_RICO,
    RHODE_ISLAND,
    SOUTH_CAROLINA,
    SOUTH_DAKOTA,
    TENNESSEE,
    TEXAS,
    US_VIRGIN_ISLANDS,
    UTAH,
    VERMONT,
    VIRGINIA,
    WASHINGTON,
    WEST_VIRGINIA,
    WISCONSIN,
    WYOMING
  ]
};
var PROVINCES = {
  ALBERTA,
  BRITISH_COLUMBIA,
  MANITOBA,
  NEW_BRUNSWICK,
  NEWFOUNDLAND_LABRADOR,
  NOVA_SCOTIA,
  NORTHWEST_TERRITORIES,
  NUNAVUT,
  ONTARIO,
  PRINCE_EDWARD_ISLAND,
  QUEBEC,
  SASKATCHEWAN,
  YUKON_TERRITORIES
};
var STATES = {
  ALABAMA,
  ALASKA,
  AMERICAN_SAMOA,
  ARIZONA,
  ARKANSAS,
  CALIFORNIA,
  COLORADO,
  CONNECTICUT,
  DELAWARE,
  DISTRICT_OF_COLUMBIA,
  FLORIDA,
  GEORGIA,
  GUAM,
  HAWAII,
  IDAHO,
  ILLINOIS,
  INDIANA,
  IOWA,
  KANSAS,
  KENTUCKY,
  LOUISIANA,
  MAINE,
  MARYLAND,
  MASSACHUSETTS,
  MICHIGAN,
  MINNESOTA,
  MISSISSIPPI,
  MISSOURI,
  MONTANA,
  NEBRASKA,
  NEVADA,
  NEW_HAMPSHIRE,
  NEW_JERSEY,
  NEW_MEXICO,
  NEW_YORK,
  NORTH_CAROLINA,
  NORTH_DAKOTA,
  OHIO,
  OKLAHOMA,
  OREGON,
  PENNSYLVANIA,
  PUERTO_RICO,
  RHODE_ISLAND,
  SOUTH_CAROLINA,
  SOUTH_DAKOTA,
  TENNESSEE,
  TEXAS,
  US_VIRGIN_ISLANDS,
  UTAH,
  VERMONT,
  VIRGINIA,
  WASHINGTON,
  WEST_VIRGINIA,
  WISCONSIN,
  WYOMING
};
var ALLOCATION_OPTIONS = [
  { value: "full-amount", text: "one time" },
  { value: "monthly", text: "monthly" },
  { value: "quarterly", text: "Every 3 months" },
  { value: "bi-annual", text: "Every 6 months" }
];
var ROLLOVER_OPTIONS = [
  { value: "no-rollover", text: "No Rollover" },
  { value: "unspent-amount", text: "Unspent Amount" },
  { value: "unclaimed-expense", text: "Unclaimed Expense" }
];
var WAITING_PERIOD_OPTIONS = [
  { value: "none", text: "None, benefits start on date of hire" },
  { value: "days", text: "# of days after date of hire" },
  {
    value: "days_round_to_month",
    text: "# of days after date of hire, round up to the start of the next month"
  }
];
var EMPLOYEE_STATE_MAP = {
  initial: "invited",
  active: "active",
  suspended: "suspended",
  terminated: "terminated",
  extension_of_benefits: "extension_of_benefits"
};
var EMPLOYEE_STATE_NAMES = {
  invited: "INVITED",
  active: "ACTIVE",
  suspended: "SUSPENDED",
  terminated: "TERMINATED",
  extension_of_benefits: "EXTENSION_OF_BENEFITS"
};
var DEPENDENT_RELATIONSHIP_MAP = {
  spouse: "SPOUSE",
  common_law: "COMMON_LAW",
  child: "CHILD",
  parent: "PARENT",
  grandparent: "GRANDPARENT",
  grandchild: "GRANDCHILD",
  uncle_aunt: "UNCLE_AUNT",
  nephew_niece: "NEPHEW_NIECE",
  sibling: "SIBLING",
  other: "OTHER",
  domestic_partnership: "DOMESTIC_PARTNERSHIP",
  ineligible_child: "INELIGIBLE_CHILD"
};
var EOI = "eoi";
var BENEFICIARY = "beneficiary";
var PILL_RADIUS = "1000px";
var ENROLLMENT_TYPE_ANNUAL = "annual";
var ENROLLMENT_TYPE_QLE = "qle";
var ENROLLMENT_TYPE_NEW_HIRE = "new_hire";
var ENROLLMENT_TYPE_ACTIVATION = "activation";
var ENROLLMENT_TYPE_BCC = "benefit_class_change";
var ENROLLMENT_TYPES = {
  ANNUAL: ENROLLMENT_TYPE_ANNUAL,
  NEW_HIRE: ENROLLMENT_TYPE_NEW_HIRE,
  QLE: ENROLLMENT_TYPE_QLE,
  ACTIVATION: ENROLLMENT_TYPE_ACTIVATION,
  BCC: ENROLLMENT_TYPE_BCC
};
var PLAN_ENROLLMENT_STATUSES = {
  OPEN: "open",
  STARTED: "started",
  PAUSED: "paused",
  SUBMITTED: "submitted",
  CLOSED: "closed"
};
var PLAN_STATUS_CREATED = "created";
var PLAN_STATUS_ACTIVE = "active";
var PLAN_STATUS_ENROLLING = "enrolling";
var PLAN_STATUS_EXPIRED = "expired";
var PLAN_STATUSES = {
  CREATED: PLAN_STATUS_CREATED,
  ACTIVE: PLAN_STATUS_ACTIVE,
  ENROLLING: PLAN_STATUS_ENROLLING,
  EXPIRED: PLAN_STATUS_EXPIRED
};
var USD = "USD";
var CAD = "CAD";
var EUR = "EUR";
var GBP = "GBP";
var CURRENCY_TYPES = {
  USD,
  CAD,
  EUR,
  GBP
};
var CURRENCY_SYMBOLS = {
  [USD]: "$",
  [CAD]: "$",
  [EUR]: "\u20AC",
  [GBP]: "\xA3"
};
var GROUP_TYPES = {
  EMPLOYER: "employer",
  BUSINESS_PROFILE: "business_profile",
  USER_GROUP: "user_group"
};
var defaultFlexDollarTermId = "FLEXIBLE_DOLLARS";
var defaultFlexDollarTerm = "flexible dollars";
var TENANT_ID = {
  LEAGUE: "league",
  PC_HEALTH: "pchealth"
};
var ROOT_NODE_ID = "root";
var PORTAL_NODE_IDS = {
  MODAL_PORTAL: "modal-portal"
};
var UTC = "UTC";
var MODAL_TITLE = "modal-title";
var MODAL_DESCRIPTION = "modal-description";
var NEW_HR_ADMIN_LINK = "/app/manage";
var OLD_HR_ADMIN_LINK = "/app/employers";

// src/common/constants/keyboard.constants.js
var KEY = {
  ARROW_DOWN: "ArrowDown",
  ARROW_LEFT: "ArrowLeft",
  ARROW_RIGHT: "ArrowRight",
  ARROW_UP: "ArrowUp",
  END: "End",
  ENTER: "Enter",
  ESC: "Escape",
  HOME: "Home",
  SPACE: " ",
  TAB: "Tab"
};

// src/common/constants/date-format.constants.ts
var DATEPICKER_DATE_FORMAT = "DD-MMM-YYYY";
var UNICODE_DATE_FORMAT = "dd-MM-yyyy";
var DATE_FORMAT = {
  year: "numeric",
  month: "long",
  day: "numeric"
};
var SHORT_DATE_FORMAT = {
  year: "numeric",
  month: "short",
  day: "numeric"
};
var SHORT_DATE_AND_TIME_FORMAT = {
  year: "numeric",
  month: "short",
  day: "numeric",
  hour: "numeric",
  minute: "numeric",
  timeZoneName: "short"
};
var SHORT_DATE_AND_TIME_FORMAT_NO_TIMEZONE = {
  year: "numeric",
  month: "short",
  day: "numeric",
  hour: "numeric",
  minute: "numeric"
};
var SHORT_MONTH_FORMAT = {
  month: "short",
  day: "numeric"
};
var LONG_MONTH_FORMAT = {
  month: "long",
  day: "numeric"
};
var LONG_WEEKDAY_DATE_FORMAT = __spreadValues({
  weekday: "long"
}, DATE_FORMAT);
var SHORT_WEEKDAY_DATE_FORMAT = __spreadValues({
  weekday: "short"
}, DATE_FORMAT);
var SHORT_WEEKDAY_FORMAT = {
  weekday: "short"
};
var NUMERIC_YEAR_MONTH_DAY = {
  year: "numeric",
  month: "numeric",
  day: "numeric"
};
var LONG_WEEKDAY = {
  weekday: "long"
};
var SHORT_MONTH_YEAR = {
  month: "short",
  year: "numeric"
};
var MONTH_YEAR = {
  month: "long",
  year: "numeric"
};

// src/common/constants/user-document.constants.js
var OTHER = "other";
var IDENTIFICATION = "identification";
var BENEFICIARY_FORM = "beneficiary_form";
var EVIDENCE_OF_INSURABILITY = "evidence_of_insurability";
var DEPENDENT_VERIFICATION = "dependent_verification";
var DOCUMENT_TYPES = [
  {
    id: "BENEFICIARY_FORM",
    value: "beneficiary_form"
  },
  { id: "IDENTIFICATION", value: "identification" },
  { id: "EVIDENCE_OF_INSURABILITY", value: EVIDENCE_OF_INSURABILITY },
  { id: "DEPENDENT_VERIFICATION", value: DEPENDENT_VERIFICATION },
  {
    id: "PROOF_OF_BUSINESS",
    value: "proof_of_business"
  },
  { id: "GYM_MEMBERSHIP", value: "gym_membership" },
  { id: "PRESCRIPTION", value: "prescription" },
  // Removed but not forgotten
  // {
  //   id: 'FOREIGN_CONTRACT',
  //   value: 'foreign_contract_worker_questionnaire',
  // },
  { id: "OTHER", value: "other" }
];
var getOptionId = (value) => {
  const option = DOCUMENT_TYPES.find((item) => item.value === value);
  return option ? option.id : false;
};

// src/common/constants/ease-out-cubic.constants.ts
var easeOutCubic = `cubic-bezier(0.33, 1, 0.68, 1)`;

// src/common/constants/role.constants.ts
var CONSUMER = "consumer";
var ADMIN = "admin";
var HR_ADMIN = "hr_admin";
var HEALTH_ADMIN = "health_admin";
var CLAIMS_AGENT = "claims_agent";
var SUPER_ADMIN = "super_admin";

// src/common/components/html-to-react/html-to-react.tsx
import React from "react";
import DOMPurify from "dompurify";
import parse, {
  domToReact,
  attributesToProps
} from "html-react-parser";

// src/common/components/html-to-react/html-to-react.utils.ts
import { cloneDeep } from "lodash";

// src/common/components/html-to-react/html-to-react.config.ts
import {
  BodyOne,
  Link,
  PrimaryButton,
  Image,
  genesisStyled
} from "@leagueplatform/genesis-commons";
import {
  HeadingText,
  ParagraphText,
  UtilityText
} from "@leagueplatform/genesis-core/";
var defaultHTMLTagOptions = {
  a: {
    component: Link
  },
  b: {
    component: ParagraphText,
    props: {
      as: "strong",
      css: {
        fontWeight: "bold"
      }
    }
  },
  p: {
    component: ParagraphText,
    props: {
      css: {
        "> a": {
          textDecoration: "underline"
        }
      }
    }
  },
  h1: {
    component: HeadingText,
    props: { level: "1", size: "xxl" }
  },
  h2: {
    component: HeadingText,
    props: { level: "2", size: "xl" }
  },
  h3: {
    component: HeadingText,
    props: { level: "3", size: "lg" }
  },
  h4: {
    component: HeadingText,
    props: { level: "4", size: "md" }
  },
  h5: {
    component: HeadingText,
    props: { level: "5", size: "sm" }
  },
  h6: {
    component: HeadingText,
    props: { level: "6", size: "xs" }
  },
  img: {
    component: Image
  },
  button: {
    component: PrimaryButton
  },
  ul: {
    component: genesisStyled(BodyOne)`list-style:revert;`,
    props: {
      as: "ul",
      marginBottom: "oneAndHalf",
      padding: "0 0 0 18px"
    }
  },
  ol: {
    component: genesisStyled(BodyOne)`list-style:revert;`,
    props: {
      as: "ol",
      marginBottom: "oneAndHalf",
      padding: "0 0 0 18px"
    }
  },
  em: {
    component: "em",
    props: { style: { fontStyle: "italic" } }
  },
  i: {
    component: "em",
    props: { style: { fontStyle: "italic" } }
  },
  sup: {
    component: UtilityText,
    props: {
      color: "$onSurfaceTextSubdued",
      size: "eyebrow"
    }
  }
};

// src/common/components/html-to-react/html-to-react.utils.ts
var applyOptionsWithDefaults = (newOptions, defaultOptions2 = cloneDeep(defaultHTMLTagOptions)) => newOptions && typeof newOptions === "object" ? Object.entries(newOptions).reduce(
  (acc, [tag, { component, props = {} }]) => {
    var _a;
    if (!acc[tag]) {
      if (!component)
        return acc;
      acc[tag] = {
        component,
        props: __spreadValues({}, props)
      };
      return acc;
    }
    if (component) {
      acc[tag].component = component;
    }
    acc[tag].props = __spreadValues(__spreadValues({}, (_a = acc[tag]) == null ? void 0 : _a.props), props);
    return acc;
  },
  defaultOptions2
) : defaultOptions2;

// src/common/components/html-to-react/html-to-react.tsx
var curateOptions = (options) => {
  const allOptions = applyOptionsWithDefaults(options);
  return {
    trim: true,
    replace({
      name,
      attribs,
      children
    }) {
      if (!attribs)
        return void 0;
      const attributeProps = attributesToProps(attribs);
      if (name in allOptions) {
        const { component: Component, props } = allOptions[name];
        return /* @__PURE__ */ React.createElement(Component, __spreadValues(__spreadValues({}, props), attributeProps), children && children.length ? domToReact(children, this) : void 0);
      }
      return void 0;
    }
  };
};
var HtmlToReact = ({
  htmlString,
  options
}) => {
  if (!htmlString)
    return null;
  const sanitizedHtml = DOMPurify.sanitize(htmlString, {
    FORCE_BODY: true
  });
  const derivedOptions = options ? curateOptions(options) : curateOptions({});
  const reactElement = parse(
    sanitizedHtml,
    derivedOptions
  );
  return /* @__PURE__ */ React.createElement(React.Fragment, null, reactElement);
};

// src/common/components/modal-portal/modal.portal.tsx
import React2, { useEffect } from "react";
import { Portal } from "@leagueplatform/genesis-core";

// src/common/utilities/create-modal-portal-element.ts
var createModalPortalElement = (modalPortalId) => {
  const modalPortalElement = document.createElement("div");
  modalPortalElement.setAttribute("id", modalPortalId);
  return document.body.appendChild(modalPortalElement);
};

// src/common/components/modal-portal/modal.portal.tsx
var ModalPortal = ({
  rootId = ROOT_NODE_ID,
  modalPortalId = PORTAL_NODE_IDS.MODAL_PORTAL,
  children
}) => {
  const rootEl = document.getElementById(rootId);
  let modalPortalEl = document.getElementById(modalPortalId);
  if (!modalPortalEl) {
    modalPortalEl = createModalPortalElement(modalPortalId);
  }
  useEffect(() => {
    rootEl == null ? void 0 : rootEl.setAttribute("aria-hidden", "true");
    return () => rootEl == null ? void 0 : rootEl.removeAttribute("aria-hidden");
  }, [rootEl]);
  return /* @__PURE__ */ React2.createElement(Portal, { container: modalPortalEl }, children);
};

// src/common/service-error.js
var ServiceError = class extends Error {
  constructor(message, errors) {
    super(message);
    this.name = "ServiceError";
    this.errors = errors;
  }
};

// src/common/utilities/mappings.js
import { lowerCase } from "lodash";
var getCurrencyForCountry = (countryCode) => {
  switch (lowerCase(countryCode)) {
    case "us":
      return "USD";
    case "ie":
      return "EUR";
    case "ca":
    default:
      return "CAD";
  }
};
var getSymbolForCurrency = (currency) => currency === "EUR" ? "\u20AC" : "$";
var GST = "GST";
var HST = "HST";
var PST = "PST";
var QST = "QST";
var RST = "RST";
var TAX_TYPES = [GST, HST, PST, QST, RST];
var TAXES_BY_PROVINCE = {
  AB: [GST],
  BC: [GST, PST],
  MB: [GST, RST],
  NB: [HST],
  NL: [HST],
  NS: [HST],
  NT: [GST],
  NU: [GST],
  ON: [HST],
  PE: [HST],
  QC: [GST, QST],
  SK: [GST, PST],
  YT: [GST]
};

// src/common/utilities/formatting.js
var currencyChecker = (data) => {
  const regex = /^$|^\$?[0-9]+\.?[0-9]?[0-9]?$/gm;
  const match = regex.exec(data);
  return match;
};
var formatCurrency = (data) => {
  const formatted = parseFloat(data).toFixed(2);
  if (Number.isNaN(formatted)) {
    return "";
  }
  return formatted;
};
var formatPhoneNumber = (input) => {
  if (input) {
    const phone = input.replace(/\D/g, "");
    if (phone) {
      const values = /(\d)?(\d\d\d)(\d\d\d)(\d\d\d\d)/.exec(phone);
      if (values) {
        const [fullNo, country, area, transfer, last4] = values;
        if (fullNo) {
          const lead = country ? `+${country} ` : "";
          return `${lead}(${area}) ${transfer}-${last4}`;
        }
      }
      return phone;
    }
  }
  return null;
};
var formatPhoneNumberForHref = (input) => {
  if (input) {
    const phone = input.replace(/\D/g, "");
    if (phone) {
      const values = /(\d)?(\d\d\d\d\d\d\d\d\d\d)/.exec(phone);
      if (values) {
        const [fullNo, country, number] = values;
        if (fullNo) {
          const lead = country ? `+${country}` : "";
          return `tel:${lead}${number}`;
        }
      }
      return `tel:${phone}`;
    }
  }
  return null;
};
var unicodePattern = /\\u([\d\w]{4})/gi;
var unescapeUnicode = (text = "") => text.replace(
  unicodePattern,
  (match, grp) => String.fromCharCode(parseInt(grp, 16))
);
var lowercaseAndHypen = (text) => text.toLowerCase().replace(/[_\s]/g, "-");
var uppercaseAndUnderscore = (text) => text.toUpperCase().replace(/[-\s]/g, "_");
var splitAtNewlines = (text = "") => text.split(/\r\n|\r|\n/g);
var camelToSnakeCase = (str) => str.replace(
  /[A-Z]/g,
  (letter, index) => index === 0 ? letter.toLowerCase() : `_${letter.toLowerCase()}`
);
var arrayToTag = (arr, retainCase = false) => {
  const taggedArray = arr.filter((el) => el != null).join(" \u2219 ").split("-").join(" ");
  return retainCase ? taggedArray : taggedArray.toLowerCase();
};

// src/common/utilities/is-entity-id.js
var isEntityId = (string) => /^[0-9a-f]{32}$/.test(string);

// src/common/utilities/normalize-policy-kind.js
var normalizePolicyKind = (policyKind) => policyKind === "lsa" ? "psa" : policyKind;

// src/common/utilities/file-reader.js
var toDataUrl = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = (e) => {
    resolve(e.target.result);
  };
  reader.onerror = (error) => {
    reject(error);
  };
  reader.readAsDataURL(file);
});
var fileReader = {
  toDataUrl
};

// src/common/utilities/date.js
import { setHours } from "date-fns";
import { zonedTimeToUtc } from "date-fns-tz";
var isDateWithinRange = (startDate, endDate, dateSubmitted) => dateSubmitted >= startDate && dateSubmitted <= endDate;
var toTimeZoneString = ({ date, timeZone }) => zonedTimeToUtc(setHours(date, 0), timeZone).toISOString();

// src/common/utilities/invert-map.ts
import { merge } from "lodash";
var invertMap = (map) => Object.keys(map).reduce((aggr, key) => {
  const values = map[key];
  const inverted = values.reduce(
    (inv, value) => __spreadProps(__spreadValues({}, inv), { [value]: key }),
    {}
  );
  return merge(inverted, aggr);
}, {});

// src/common/utilities/currencyproptype.js
import { PropTypes } from "prop-types";
var currencyPropType = PropTypes.shape({
  C: PropTypes.string,
  M: PropTypes.number,
  F: PropTypes.number
});

// src/common/utilities/is-image-content-type.js
import { startsWith } from "lodash";
var isImageContentType = (contentType) => startsWith(contentType, "image/");

// src/common/utilities/get-active-group.js
var getActiveGroup = (groups = []) => groups.find(({ suspended }) => !suspended) || groups[0];
var getActiveEmployerGroup = (groups = []) => groups.find(
  ({ suspended, group_type: groupType }) => !suspended && groupType === GROUP_TYPES.EMPLOYER
);
var getActiveBusinessProfileGroup = (groups = []) => groups.find(
  ({ suspended, groupType }) => !suspended && groupType === GROUP_TYPES.BUSINESS_PROFILE
);

// src/common/utilities/create-lifecycle-types.js
var createLifecycleTypes = (type) => {
  const BASE = type;
  const VISITED = `${type}_VISITED`;
  const EXITED = `${type}_EXITED`;
  return {
    BASE,
    VISITED,
    EXITED,
    visit: (props) => ({ type: VISITED, payload: { props } }),
    exit: (props) => ({ type: EXITED, payload: { props } })
  };
};

// src/common/utilities/validation.js
var isNumeric = (value) => /^\d+$/.test(value);
var isAlphanumeric = (value) => /^(?=.*?\d)(?=.*?[a-z])[a-z\d]+$/i.test(value);
var isPhoneNumber = (value) => {
  if (!value)
    return false;
  const number = value.replace(/[-\s\(\)]/g, "");
  return /^(\+)?\d{5,15}$/.test(number);
};
var VALID_EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
var isEmail = (value) => VALID_EMAIL_REGEX.test(value);

// src/common/utilities/parse-query.js
function parseQuery(queryString) {
  const query = {};
  if (queryString) {
    const noQuestionMarkQueryString = (queryString[0] === "?" ? queryString.substr(1) : queryString).replace(/(\?lang)=(.*)/gm, "");
    const pairs = noQuestionMarkQueryString.split("&");
    for (let i = 0; i < pairs.length; i += 1) {
      const pair = pairs[i].split("=");
      query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || "");
    }
  }
  return query;
}

// src/common/utilities/react-router-hash-link.jsx
import React3, { useCallback } from "react";
import PropTypes2 from "prop-types";
import { Link as Link2 } from "@leagueplatform/routing";
var hashFragment = "";
var observer = null;
var asyncTimerId = null;
var scrollFunction = null;
function reset() {
  hashFragment = "";
  if (observer !== null)
    observer.disconnect();
  if (asyncTimerId !== null) {
    window.clearTimeout(asyncTimerId);
    asyncTimerId = null;
  }
}
function getElAndScroll() {
  const element = document.getElementById(hashFragment);
  if (element !== null) {
    scrollFunction(element);
    reset();
    return true;
  }
  return false;
}
function hashLinkScroll() {
  window.setTimeout(() => {
    if (getElAndScroll() === false) {
      if (observer === null) {
        observer = new MutationObserver(getElAndScroll);
      }
      observer.observe(document, {
        attributes: true,
        childList: true,
        subtree: true
      });
      asyncTimerId = window.setTimeout(() => {
        reset();
      }, 1e4);
    }
  }, 0);
}
function HashLink(props) {
  const _a = props, { onClick, to, scroll, smooth } = _a, otherProps = __objRest(_a, ["onClick", "to", "scroll", "smooth"]);
  const handleClick = useCallback(
    (e) => {
      reset();
      if (onClick)
        onClick(e);
      if (typeof to === "string") {
        hashFragment = to.split("#").slice(1).join("#");
      } else if (typeof to === "object" && typeof to.hash === "string") {
        hashFragment = to.hash.replace("#", "");
      }
      if (hashFragment !== "") {
        scrollFunction = scroll || ((el) => smooth ? el.scrollIntoView({ behavior: "smooth" }) : el.scrollIntoView());
        hashLinkScroll();
      }
    },
    [onClick, to, scroll, smooth]
  );
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    /* @__PURE__ */ React3.createElement(Link2, __spreadProps(__spreadValues({}, otherProps), { onClick: handleClick, to }), props.children)
  );
}
HashLink.propTypes = {
  onClick: PropTypes2.func,
  children: PropTypes2.node,
  scroll: PropTypes2.func,
  to: PropTypes2.oneOfType([PropTypes2.string, PropTypes2.object])
};

// src/common/utilities/open-in-tab.js
var openInTab = (url) => {
  window.open(url, "_blank", "noopener=yes,noreferrer=yes");
};

// src/common/utilities/is-quebec.js
var isQuebec = (province) => {
  if (province && typeof province.localeCompare === "function") {
    return province.localeCompare(QUEBEC, "en", { sensitivity: "base" }) === 0;
  }
  return province === QUEBEC;
};

// src/common/utilities/is-mobile.js
function isMobile() {
  return /iphone|ipad|ipod|android/i.test(
    window.navigator.userAgent.toLowerCase()
  );
}

// src/common/utilities/omit-keys-with-empty-values.js
import { chain, isUndefined, isNull } from "lodash";
var isEmptyString = (val) => val === "";
var omitKeysWithEmptyValues = (data) => chain(data).omitBy(isUndefined).omitBy(isNull).omitBy(isEmptyString).value();

// src/common/utilities/truncate-with-ellipses.js
var truncateWithEllipses = (text = "", characterLength = 150) => text.length <= characterLength ? text : `${text.slice(0, characterLength)}...`;

// src/common/utilities/address-fields.js
function getPostalCodeTranslationId(countryCode) {
  if (countryCode === UNITED_STATES) {
    return "ZIP_CODE";
  }
  return "POSTAL_CODE";
}
function getSentenceCasePostalCodeTranslationId(countryCode) {
  if (countryCode === UNITED_STATES) {
    return "ZIP_CODE_SENTENCE_CASE";
  }
  return "POSTAL_CODE_SENTENCE_CASE";
}
function getCityTranslationId(countryCode) {
  switch (countryCode) {
    case CANADA:
    case UNITED_STATES:
      return "CITY";
    default:
      return "CITY_TOWN";
  }
}
function getProvinceTranslationId(countryCode) {
  switch (countryCode) {
    case CANADA:
      return "PROVINCE";
    case UNITED_STATES:
      return "STATE";
    default:
      return "PROVINCE_COUNTY";
  }
}

// src/common/utilities/is-absolute-url.js
var isAbsoluteUrl = (url) => url.toLowerCase().startsWith("http");

// src/common/utilities/is-external-url.js
var isExternalUrl = (url) => !!((url == null ? void 0 : url.match(/^http/i)) && !url.match(new RegExp(window.location.hostname), "ig"));

// src/common/utilities/is-valid-url.util.ts
var defaultOptions = {
  protocol: "http",
  pathname: "",
  hash: "",
  host: "",
  hostname: "",
  href: "",
  origin: "",
  password: "",
  port: "",
  search: "",
  username: ""
};
var isValidUrl = (url, options = defaultOptions) => {
  const consolidatedOptions = __spreadValues(__spreadValues({}, defaultOptions), options);
  try {
    const urlObject = new URL(url);
    const isValid = Object.entries(consolidatedOptions).every(
      ([optionName, optionValue]) => {
        var _a;
        return (_a = urlObject == null ? void 0 : urlObject[optionName]) == null ? void 0 : _a.includes(
          optionValue
        );
      }
    );
    return isValid;
  } catch (e) {
    return false;
  }
};

// src/common/utilities/get-contentful-image-url.util.ts
var getContentfulImageUrl = (contentfulImageAsset) => `https:${contentfulImageAsset}`;

// src/common/utilities/get-parameter-by-name.js
var getParameterByName = (name, url = window.location.href) => {
  const cleanName = name.replace(/[\]]/g, "\\$&");
  const regex = new RegExp(`[?&]${cleanName}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url);
  if (!results)
    return null;
  if (!results[2])
    return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
};

// src/common/utilities/is-kpmg.util.ts
var isKPMG = (employerName = "") => employerName.includes("KPMG");

// src/common/utilities/get-typeform-url.util.ts
import { getCurrentLocale, DEFAULT_LOCALE } from "@leagueplatform/locales";
var getTypeformUrl = (ids) => {
  let typeformUrlId = ids.en;
  const currentLocale = getCurrentLocale(DEFAULT_LOCALE);
  if (currentLocale.includes("fr")) {
    typeformUrlId = ids.fr;
  } else if (currentLocale.includes("es")) {
    typeformUrlId = ids.es;
  }
  return {
    url: `https://leagueca.typeform.com/to/${typeformUrlId}`,
    id: typeformUrlId
  };
};

// src/common/utilities/normalize-url.ts
var STAGING_URL = "https://app.staging.league.dev";
var normalizeUrl = (url) => {
  if (url.trim().length !== 0 && !isAbsoluteUrl(url)) {
    if (url.charAt(0) !== "/") {
      return `/${url}`;
    }
  }
  return url;
};
var normalizeInternalUrl = (url = "") => {
  if (url == null ? void 0 : url.match(new RegExp(STAGING_URL, "ig"))) {
    return url.replace(new RegExp(STAGING_URL, "ig"), "");
  }
  return !isExternalUrl(url) && (url == null ? void 0 : url.match(new RegExp(window.location.origin, "i"))) ? url == null ? void 0 : url.replace(new RegExp(window.location.origin, "ig"), "") : normalizeUrl(url);
};

// src/common/utilities/download-blob-as-file.util.ts
function downloadBlobAsFile(blob, filename) {
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);
  link.setAttribute("style", "display: none");
  link.setAttribute("download", filename);
  link.setAttribute("href", url);
  link.setAttribute("target", "_blank");
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

// src/common/utilities/parse-url.js
var whiteSpaceRe = /^\s*$/;
function parseUrl(url) {
  if (!url || whiteSpaceRe.test(url)) {
    throw new Error(`Error in parseUrl: could not parse ${url} as url`);
  }
  const a = document.createElement("a");
  a.href = url;
  const {
    protocol,
    // "http:"
    host,
    // "example.com:3000"
    hostname,
    // "example.com"
    port,
    // "3000"
    pathname,
    // "/pathname/"
    hash,
    // "#hash"
    search,
    // "?search=test"
    href,
    // http://example.com
    origin
    // http://example.com:3000
  } = a;
  return {
    protocol,
    host,
    hostname,
    port,
    pathname,
    hash,
    search,
    href,
    origin
  };
}

// src/common/hooks/use-confirm/use-confirm.hook.js
import { useState } from "react";
function useConfirm({ onConfirm = () => {
}, onCancel = () => {
} } = {}) {
  const [isConfirming, setIsConfirming] = useState(false);
  return {
    isConfirming,
    setIsConfirming,
    onConfirm: () => {
      onConfirm();
      setIsConfirming(false);
    },
    onCancel: () => {
      onCancel();
      setIsConfirming(false);
    }
  };
}

// src/common/hooks/use-on-escape/use-on-escape.hook.js
import { useEffect as useEffect2 } from "react";
var useOnEscape = (onEscape) => {
  useEffect2(() => {
    const escKeyListener = (evt) => {
      if (evt.key === "Escape" || evt.key === "Esc") {
        onEscape();
      }
    };
    window.addEventListener("keyup", escKeyListener);
    return () => window.removeEventListener("keyup", escKeyListener);
  }, [onEscape]);
};

// src/common/hooks/use-document-title/use-document-title.hook.js
import { useEffect as useEffect3 } from "react";
import { useIntl } from "react-intl";
var useDocumentTitle = (title) => {
  const { formatMessage } = useIntl();
  useEffect3(() => {
    document.title = formatMessage(
      {
        id: "DOCUMENT_TITLE"
      },
      {
        title
      }
    );
  }, [formatMessage, title]);
};

// src/common/hooks/use-debounce/use-debounce.hook.js
import { useState as useState2, useEffect as useEffect4 } from "react";
function useDebounce(value, delay, initialValue = null) {
  const [debouncedValue, setDebouncedValue] = useState2(initialValue != null ? initialValue : value);
  useEffect4(
    () => {
      const handler = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);
      return () => {
        clearTimeout(handler);
      };
    },
    // Only re-call effect if value changes
    // You could also add the "delay" var to inputs array if you ...
    // ... need to be able to change that dynamically.
    [value, delay]
  );
  return debouncedValue;
}

// src/common/hooks/use-outside-click/use-outside-click.hook.ts
import { useEffect as useEffect5 } from "react";
var useOutsideClick = (refs, handler) => {
  useEffect5(() => {
    const refsArray = Array.isArray(refs) ? refs : [refs];
    function handleClickOutside(event) {
      if (!handler)
        return;
      if (event.target === document.getElementsByTagName("html")[0] && event.clientX >= document.documentElement.offsetWidth)
        return;
      const containedToAnyRefs = refsArray.some(
        (rf) => {
          var _a, _b;
          return !!((_b = (_a = rf == null ? void 0 : rf.current) == null ? void 0 : _a.contains) == null ? void 0 : _b.call(_a, event.target));
        }
      );
      if (!containedToAnyRefs) {
        handler();
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [refs, handler]);
};

// src/common/hooks/use-checkbox-confirm/use-checkbox-confirm.hook.js
import { useState as useState3 } from "react";
function useCheckboxConfirm({ onConfirm = () => {
} } = {}) {
  const [isChecked, setIsChecked] = useState3(false);
  const [isErrored, setIsErrored] = useState3(false);
  return {
    isChecked,
    setIsChecked,
    isErrored,
    setIsErrored,
    handleChange: () => {
      setIsChecked(!isChecked);
      if (isErrored) {
        setIsErrored(false);
      }
    },
    onConfirm: (e) => {
      if (!isChecked) {
        setIsErrored(true);
      } else {
        setIsChecked(false);
        setIsErrored(false);
        onConfirm(e);
      }
    }
  };
}

// src/common/hooks/use-tab-focus/use-tab-focus.hook.ts
import { useState as useState4 } from "react";
var useTabFocus = (tabArray, defaultTabIndex = 0) => {
  const [focusedTabIndex, setFocusedTabIndex] = useState4(defaultTabIndex);
  const indexUp = () => {
    if (focusedTabIndex !== tabArray.length - 1) {
      setFocusedTabIndex(focusedTabIndex + 1);
    } else {
      setFocusedTabIndex(0);
    }
  };
  const indexDown = () => {
    if (focusedTabIndex !== 0) {
      setFocusedTabIndex(focusedTabIndex - 1);
    } else {
      setFocusedTabIndex(tabArray.length - 1);
    }
  };
  const handleKeyUp = ({ key }) => {
    switch (key) {
      case KEY.ARROW_UP:
      case KEY.ARROW_LEFT:
        indexDown();
        break;
      case KEY.ARROW_DOWN:
      case KEY.ARROW_RIGHT:
        indexUp();
        break;
      default:
        break;
    }
  };
  return { handleKeyUp, focusedTabIndex };
};

// src/common/hooks/use-prefers-reduced-motion/use-prefers-reduced-motion.hook.ts
import { useState as useState5, useEffect as useEffect6 } from "react";
var QUERY = "(prefers-reduced-motion: no-preference)";
var getInitialState = () => !window.matchMedia(QUERY).matches;
function usePrefersReducedMotion() {
  const [prefersReducedMotion, setPrefersReducedMotion] = useState5(getInitialState);
  useEffect6(() => {
    const mediaQueryList = window.matchMedia(QUERY);
    const listener = (event) => {
      setPrefersReducedMotion(!event.matches);
    };
    mediaQueryList.addEventListener("change", listener);
    return () => {
      mediaQueryList.removeEventListener("change", listener);
    };
  }, []);
  return prefersReducedMotion;
}

// src/common/hooks/use-url-param/use-url-param.hook.ts
import { useLocation, useHistory, matchPath } from "@leagueplatform/routing";
var useUrlParam = (name) => {
  const location = useLocation();
  const history = useHistory();
  const getParams = () => new URLSearchParams(location.search);
  const getParam = () => getParams().get(name);
  const matchParamPath = (path) => {
    const param = getParam();
    if (typeof param === "string") {
      return matchPath(param, path);
    }
    return null;
  };
  const makeLocation = (params) => __spreadProps(__spreadValues({}, location), {
    search: params.toString()
  });
  const push = (params) => {
    const prevParams = getParams().toString();
    if (prevParams !== params.toString()) {
      history.push(makeLocation(params));
    }
  };
  const linkToParam = (path) => {
    const params = getParams();
    params.set(name, path);
    return makeLocation(params);
  };
  const setParam = (path) => {
    if (!path)
      return;
    const params = getParams();
    params.set(name, path);
    push(params);
  };
  const removeParam = () => {
    const params = getParams();
    params.delete(name);
    push(params);
  };
  return {
    urlParam: getParam(),
    matchParamPath,
    setParam,
    removeParam,
    linkToParam
  };
};

// src/common/hooks/use-flex-dollar-text/use-flex-dollar-text.hook.jsx
import React4 from "react";
import { useIntl as useIntl2 } from "@leagueplatform/locales";
var formatStrong = (msg) => /* @__PURE__ */ React4.createElement("strong", null, msg);
var useMultipleBenefitsText = ({ strong = formatStrong }) => {
  const { formatMessage } = useIntl2();
  const getMultipleBenefitsMessage = (benefits) => {
    const benefitsLength = benefits.length;
    const flexBenefits = benefits.slice(0, benefitsLength - 1);
    const lastBenefit = benefits[benefitsLength - 1];
    const lastBenefitText = /* @__PURE__ */ React4.createElement(React4.Fragment, null, formatMessage({ id: "AND" }), " ", formatMessage(
      { id: "FLEX_DOLLAR_INFO_TEXT_MULTIPLE" },
      __spreadProps(__spreadValues({}, lastBenefit), { strong })
    ), ".");
    const leftoverFlexMessages = flexBenefits.map(
      (benefit) => /* @__PURE__ */ React4.createElement(React4.Fragment, null, formatMessage(
        { id: "FLEX_DOLLAR_INFO_TEXT_MULTIPLE" },
        __spreadProps(__spreadValues({}, benefit), { strong })
      ), benefitsLength === 2 ? " " : ", "),
      ""
    );
    return /* @__PURE__ */ React4.createElement(React4.Fragment, null, leftoverFlexMessages, lastBenefitText);
  };
  return { getMultipleBenefitsMessage };
};
var useFlexDollarText = (_a) => {
  var _b = _a, { leftoverFlexBenefits } = _b, props = __objRest(_b, ["leftoverFlexBenefits"]);
  const { formatMessage } = useIntl2();
  const { getMultipleBenefitsMessage } = useMultipleBenefitsText(props);
  if (leftoverFlexBenefits.length === 1) {
    return formatMessage(
      { id: "FLEX_DOLLAR_INFO_TEXT_SINGLE" },
      __spreadValues({}, leftoverFlexBenefits[0])
    );
  }
  if (leftoverFlexBenefits.length > 1) {
    return getMultipleBenefitsMessage(leftoverFlexBenefits);
  }
  return "";
};
var useLeftoverFlexBenefitText = (_a) => {
  var _b = _a, {
    leftoverFlexBenefits
  } = _b, props = __objRest(_b, [
    "leftoverFlexBenefits"
  ]);
  const { formatMessage } = useIntl2();
  const { getMultipleBenefitsMessage } = useMultipleBenefitsText(props);
  if (leftoverFlexBenefits.length === 1) {
    return formatMessage(
      { id: "LEFTOVER_FLEX_DOLLAR_INFO_TEXT_SINGLE" },
      __spreadProps(__spreadValues({}, leftoverFlexBenefits[0]), {
        strong: formatStrong
      })
    );
  }
  if (leftoverFlexBenefits.length > 1) {
    return getMultipleBenefitsMessage(leftoverFlexBenefits);
  }
  return "";
};

// src/common/hooks/use-handle-dropdown/use-handle-dropdown-hook.js
import { useEffect as useEffect7 } from "react";
var useHandleDropdown = ({ isOpen, setIsOpen, ref }) => {
  useEffect7(() => {
    const handleClickedOutside = (event) => {
      if (isOpen && ref.current && !ref.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    const handleEsc = (event) => {
      if (event.key === KEY.ESC) {
        setIsOpen(false);
      }
    };
    if (isOpen) {
      document.addEventListener("click", handleClickedOutside);
      document.addEventListener("keydown", handleEsc);
    }
    return () => {
      document.removeEventListener("click", handleClickedOutside);
      document.removeEventListener("keydown", handleEsc);
    };
  }, [isOpen, setIsOpen, ref]);
};

// src/common/hooks/use-list-items-focus/use-list-items-focus-hook.js
import { useEffect as useEffect8, useRef } from "react";
var getCurrentRef = (ref) => {
  var _a;
  return (_a = ref.current) != null ? _a : ref;
};
var useListItemsFocusHook = (isOpen, refsMenuItems, refContainer) => {
  const currentFocus = useRef(0);
  useEffect8(() => {
    const copyRefContainer = (refContainer == null ? void 0 : refContainer.current) || null;
    const handleKeyDown = (event) => {
      switch (event.key) {
        case KEY.ARROW_DOWN:
          event.preventDefault();
          if (currentFocus.current < refsMenuItems.length - 1) {
            currentFocus.current += 1;
            const currentRef = getCurrentRef(
              refsMenuItems[currentFocus.current]
            );
            currentRef.focus();
          }
          break;
        case KEY.ARROW_UP:
          event.preventDefault();
          if (currentFocus.current > 0) {
            currentFocus.current -= 1;
            const currentRef = getCurrentRef(
              refsMenuItems[currentFocus.current]
            );
            currentRef.focus();
          }
          break;
        default:
          break;
      }
    };
    if (isOpen && refsMenuItems.length && copyRefContainer) {
      if (refsMenuItems[0].current) {
        refsMenuItems[0].current.focus();
      } else {
        refsMenuItems[0].focus();
      }
      copyRefContainer.addEventListener("keydown", handleKeyDown);
    }
    return () => {
      if (copyRefContainer) {
        copyRefContainer.removeEventListener("keydown", handleKeyDown);
      }
    };
  }, [isOpen, refsMenuItems, refContainer]);
};

// src/common/hooks/use-scroll-top-on-location-change/use-scroll-top-on-location-change.hook.ts
import { useEffect as useEffect9 } from "react";
import { useLocation as useLocation2 } from "@leagueplatform/routing";
var useScrollTopOnLocationChange = () => {
  const { pathname } = useLocation2();
  useEffect9(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
};

// src/common/hooks/use-format-date-by-user-profile-location/use-format-date-by-user-profile-location.hook.ts
import { useCallback as useCallback2 } from "react";
import { useIntl as useIntl3 } from "@leagueplatform/locales";

// src/common/hooks/use-get-user-profile/use-get-user-profile.hook.tsx
import { useQuery } from "react-query";
import {
  getUserProfile,
  GET_USER_PROFILE_MESSAGE_TYPE
} from "@leagueplatform/user-profile-api";

// src/common/utilities/deep-camelcase-keys.ts
import camelcaseKeys from "camelcase-keys";
var deepCamelCaseKeys = (input) => camelcaseKeys(input, { deep: true });

// src/common/hooks/use-get-user-profile/use-get-user-profile.hook.tsx
var useGetUserProfile = (options, userId) => useQuery(
  [GET_USER_PROFILE_MESSAGE_TYPE, userId || ""],
  () => getUserProfile(userId),
  __spreadValues({
    select: (data) => deepCamelCaseKeys(data)
  }, options)
);

// src/common/hooks/use-format-date-by-user-profile-location/use-format-date-by-user-profile-location.hook.ts
var useFormatDateByUserProfileLocation = () => {
  const { formatDate } = useIntl3();
  const { data: userProfileData } = useGetUserProfile({ staleTime: Infinity });
  const { defaultTimezone } = userProfileData || {};
  const formatDateWithUserProfileLocation = useCallback2(
    (value, opts) => formatDate(value, __spreadProps(__spreadValues({}, opts), { timeZone: defaultTimezone })),
    [defaultTimezone, formatDate]
  );
  return { formatDateWithUserProfileLocation };
};

// src/common/hooks/use-swipe-guestures/use-swipe-gestures.hook.ts
import { useEffect as useEffect10, useState as useState6 } from "react";
var SWIPE_DIRECTION = /* @__PURE__ */ ((SWIPE_DIRECTION2) => {
  SWIPE_DIRECTION2["right"] = "RIGHT";
  SWIPE_DIRECTION2["left"] = "LEFT";
  SWIPE_DIRECTION2["up"] = "UP";
  SWIPE_DIRECTION2["down"] = "DOWN";
  return SWIPE_DIRECTION2;
})(SWIPE_DIRECTION || {});
var SWIPE_ORIENTATION = /* @__PURE__ */ ((SWIPE_ORIENTATION2) => {
  SWIPE_ORIENTATION2["vertical"] = "VERTICAL";
  SWIPE_ORIENTATION2["horizontal"] = "HORIZONTAL";
  return SWIPE_ORIENTATION2;
})(SWIPE_ORIENTATION || {});
var useSwipeGestures = (ref, orientation) => {
  const [swipeDirection, setSwipeDirection] = useState6("");
  const [touchStartClient, setTouchStartClient] = useState6([
    null,
    null
  ]);
  if (!ref) {
    console.warn("[useSwipeGesture] Ref element not found: ", ref);
  }
  useEffect10(() => {
    const { current } = ref;
    const handleTouchStart = (e) => {
      setSwipeDirection("");
      const { clientX, clientY } = e.touches[0];
      setTouchStartClient([clientX, clientY]);
    };
    const handleTouchEnd = (e) => {
      const [startClientX, startClientY] = touchStartClient;
      const { clientX: endClientX, clientY: endClientY } = e.changedTouches[0];
      if (typeof startClientX === "number" && typeof startClientY === "number") {
        if (orientation !== "VERTICAL" /* vertical */ && Math.abs(startClientX - endClientX) > Math.abs(startClientY - endClientY)) {
          if (startClientX > endClientX) {
            setSwipeDirection("RIGHT" /* right */);
          } else if (startClientX < endClientX) {
            setSwipeDirection("LEFT" /* left */);
          }
        } else if (orientation !== "HORIZONTAL" /* horizontal */ && Math.abs(startClientX - endClientX) < Math.abs(startClientY - endClientY)) {
          if (startClientY > endClientY) {
            setSwipeDirection("DOWN" /* down */);
          } else if (startClientY < endClientY) {
            setSwipeDirection("UP" /* up */);
          }
        }
      }
    };
    if (current) {
      current.addEventListener("touchstart", handleTouchStart);
      current.addEventListener("touchend", handleTouchEnd);
      return () => {
        current.removeEventListener("touchstart", handleTouchStart);
        current.removeEventListener("touchend", handleTouchEnd);
      };
    }
    return () => {
    };
  }, [ref, orientation, touchStartClient]);
  return swipeDirection;
};

// src/common/hooks/use-online-status/use-online-status.hook.tsx
import { useState as useState7, useEffect as useEffect11 } from "react";
var useOnlineStatus = () => {
  var _a;
  const navigatorOnLineIsSupported = typeof ((_a = window == null ? void 0 : window.navigator) == null ? void 0 : _a.onLine) === "boolean";
  const [isOnline, setIsOnline] = useState7(
    navigatorOnLineIsSupported ? window.navigator.onLine : true
  );
  useEffect11(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);
    if (navigatorOnLineIsSupported) {
      window.addEventListener("online", handleOnline);
      window.addEventListener("offline", handleOffline);
    } else {
      console.warn("[useOnlineStatus] window.navigator.onLine not supported.");
    }
    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, [navigatorOnLineIsSupported]);
  return { isOnline, isOffline: !isOnline };
};

// src/common/hooks/use-analytics-identify/use-analytics-identify.hook.tsx
import { useEffect as useEffect12 } from "react";
import { identify } from "@leagueplatform/analytics";
var useAnalyticsIdentify = (user, useGetUserProfileHook = useGetUserProfile) => {
  const { data: userProfile } = useGetUserProfileHook();
  const userId = userProfile == null ? void 0 : userProfile.userId;
  useEffect12(() => {
    if (userId) {
      identify(__spreadProps(__spreadValues({}, user), {
        id: userId
      }));
    }
  }, [userId, user]);
};

// src/lib/jest/mock-pose.js
var posed = () => () => "Posed";
posed.div = () => "posed-div";
var mockPose = {
  __esModule: true,
  default: posed
};

// src/lib/jest/mock-resize-observer.js
var mockResizeObserver = () => {
  class ResizeObserver {
    constructor() {
      this.observe = () => {
      };
      this.disconnect = () => {
      };
    }
  }
  global.ResizeObserver = ResizeObserver;
};

// src/lib/storybook/react-query.decorator.tsx
import React6 from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
function reactQueryDecorator(Story, { parameters: { queryStates = [] } = {} }) {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: { staleTime: Infinity, cacheTime: Infinity }
    }
  });
  queryStates.forEach(
    ({
      queryKey,
      queryValue,
      error,
      status
    }) => {
      queryClient.setQueryData(queryKey, queryValue);
      const currentQueryCache = queryClient.getQueryCache();
      const currentQuery = currentQueryCache.find(queryKey);
      if (error || status === "error") {
        currentQuery.state.error = error || true;
        currentQuery.state.status = "error";
      } else if (status) {
        currentQuery.state.status = status;
      }
    }
  );
  return /* @__PURE__ */ React6.createElement(QueryClientProvider, { client: queryClient }, /* @__PURE__ */ React6.createElement(Story, null), /* @__PURE__ */ React6.createElement(ReactQueryDevtools, null));
}

// src/lib/react-hook-form/components/form-provider.component.tsx
import React7, { useMemo } from "react";
import { Box } from "@leagueplatform/genesis-core";
import {
  FormProvider as ReactHookFormProvider,
  useForm
} from "react-hook-form";
var defaultSubmitHandler = (_, event) => event == null ? void 0 : event.preventDefault();
var FormProvider = ({
  formMethods,
  formOptions,
  includesFormElement = true,
  css,
  onSubmit = defaultSubmitHandler,
  onError,
  children
}) => {
  const methods = useForm(formOptions != null ? formOptions : {});
  const derivedMethods = useMemo(
    () => formMethods != null ? formMethods : methods,
    [formMethods, methods]
  );
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    /* @__PURE__ */ React7.createElement(ReactHookFormProvider, __spreadValues({}, derivedMethods), includesFormElement ? /* @__PURE__ */ React7.createElement(
      Box,
      {
        as: "form",
        css,
        onSubmit: derivedMethods.handleSubmit(onSubmit, onError)
      },
      children
    ) : children)
  );
};

// src/lib/react-hook-form/components/controlled-form-field.component.tsx
import React8, { cloneElement, isValidElement } from "react";
import { FormField } from "@leagueplatform/genesis-core";

// src/lib/react-hook-form/hooks/use-input.hook.ts
import { useMemo as useMemo3 } from "react";
import { useFormContext } from "react-hook-form";

// src/lib/react-hook-form/hooks/use-input-status.hook.ts
import { useMemo as useMemo2 } from "react";
var useInputStatus = (inputName, formState, optionalStatus) => {
  const error = formState.errors[inputName];
  const inputValidationState = useMemo2(() => {
    if (error && typeof (error == null ? void 0 : error.message) === "string")
      return { inputStatus: "error", statusMessage: error.message };
    if (optionalStatus)
      return optionalStatus;
    return { inputStatus: void 0, statusMessage: void 0 };
  }, [error, optionalStatus]);
  return inputValidationState;
};

// src/lib/react-hook-form/hooks/use-input.hook.ts
var useInput = (inputName, inputOptions = {}, optionalStatus) => {
  const { register, formState } = useFormContext();
  const inputValidationState = useInputStatus(
    inputName,
    formState,
    optionalStatus
  );
  const isDirty = formState.dirtyFields[inputName];
  const isTouched = formState.touchedFields[inputName];
  const field = useMemo3(
    () => register(inputName, inputOptions),
    [inputName, inputOptions, register]
  );
  return {
    field,
    inputValidationState,
    isDirty,
    isTouched
  };
};

// src/lib/react-hook-form/components/controlled-form-field.component.tsx
var ControlledFormField = (_a) => {
  var _b = _a, {
    name,
    inputOptions = {},
    optionalStatus,
    children
  } = _b, props = __objRest(_b, [
    "name",
    "inputOptions",
    "optionalStatus",
    "children"
  ]);
  const { field, inputValidationState } = useInput(
    name,
    inputOptions,
    optionalStatus
  );
  const required = Boolean(inputOptions == null ? void 0 : inputOptions.required);
  const { inputStatus, statusMessage } = inputValidationState;
  return /* @__PURE__ */ React8.createElement(
    FormField,
    __spreadValues({
      name,
      inputStatus,
      statusMessage,
      required
    }, props),
    isValidElement(children) && cloneElement(children, field)
  );
};

// src/lib/react-hook-form/components/controlled-fieldset.component.tsx
import React9, { Children, cloneElement as cloneElement2, isValidElement as isValidElement2 } from "react";
import { Fieldset } from "@leagueplatform/genesis-core";
var ControlledFieldset = (_a) => {
  var _b = _a, {
    name,
    inputOptions = {},
    optionalStatus,
    children
  } = _b, props = __objRest(_b, [
    "name",
    "inputOptions",
    "optionalStatus",
    "children"
  ]);
  const { field, inputValidationState } = useInput(
    name,
    inputOptions,
    optionalStatus
  );
  const required = Boolean(inputOptions == null ? void 0 : inputOptions.required);
  const { inputStatus, statusMessage } = inputValidationState;
  return /* @__PURE__ */ React9.createElement(
    Fieldset,
    __spreadValues({
      inputStatus,
      statusMessage,
      required
    }, props),
    Children.map(
      children,
      (child) => isValidElement2(child) && cloneElement2(child, __spreadProps(__spreadValues({}, field), {
        inputStatus
      }))
    )
  );
};

// src/lib/react-hook-form/hooks/use-controlled-input.hook.ts
import {
  useFormContext as useFormContext2,
  useController
} from "react-hook-form";
var useControlledInput = (inputOptions, optionalStatus) => {
  const { control } = useFormContext2();
  const controlledInput = useController(__spreadValues({
    control
  }, inputOptions));
  const inputValidationState = useInputStatus(
    inputOptions == null ? void 0 : inputOptions.name,
    controlledInput == null ? void 0 : controlledInput.formState,
    optionalStatus
  );
  return __spreadProps(__spreadValues({}, controlledInput), { inputValidationState });
};

// src/lib/react-hook-form/index.ts
import {
  FormProvider as FormProvider2,
  useController as useController2,
  useForm as useForm2,
  useFormContext as useFormContext3,
  useFormState,
  useWatch
} from "react-hook-form";

// src/common/utilities/transform-anchor-tag.util.ts
var transformAnchorTag = (node) => {
  var _a, _b, _c, _d, _e;
  if (node.nodeName !== "A" || !node) {
    return;
  }
  const isExternalLink = isExternalUrl(node.getAttribute("href"));
  const isMailLink = (_b = (_a = node.getAttribute("href")) == null ? void 0 : _a.includes("mailto:")) != null ? _b : false;
  const isPhoneLink = (_d = (_c = node.getAttribute("href")) == null ? void 0 : _c.includes("tel:")) != null ? _d : false;
  const isInternalLink = !isExternalLink && !isMailLink && !isPhoneLink;
  if (isInternalLink) {
    const url = ((_e = node.getAttribute("href")) == null ? void 0 : _e.replace(/^.*\/\/[^/]+/, "")) || "";
    node.setAttribute("href", url);
  } else if (isExternalLink) {
    node.setAttribute("rel", "noopener noreferrer");
  }
};

// src/common/utilities/help-center-links.js
import {
  DEFAULT_LOCALE as DEFAULT_LOCALE2,
  getAppSupportedLocale,
  supportedLocaleList
} from "@leagueplatform/locales";
var PRODUCT_TYPES = {
  HEALTH_SAVINGS_ACCOUNT: "health_savings_account",
  FLEXIBLE_SPENDING_ACCOUNT: "flexible_spending_account",
  HFSA: "healthcare_flexible_spending_account",
  DCFSA: "dependent_care_flexible_spending_account",
  LPFSA: "limited_purpose_flexible_spending_account",
  CRA: "cra"
};
var HELP_CENTER_BASE_URL = {
  CA: "https://help.league.com",
  US: "https://ushelp.league.com",
  KPMG: "https://kpmghelp.league.com"
};
var getLanguageCode = (lang) => {
  switch (lang) {
    case "en":
      return "en_US";
    default:
      return lang;
  }
};
var HELP_CENTER = "help_center";
var getHelpDeskLink = (group) => {
  var _a, _b, _c;
  const links = group == null ? void 0 : group.links;
  const countryCodeOrEmployer = isKPMG((_a = group == null ? void 0 : group.group) == null ? void 0 : _a.name) ? "KPMG" : (_b = group == null ? void 0 : group.group) == null ? void 0 : _b.country_code;
  const groupHelpLink = (_c = links == null ? void 0 : links.find((link) => link.type === HELP_CENTER)) == null ? void 0 : _c.url;
  return groupHelpLink || HELP_CENTER_BASE_URL[countryCodeOrEmployer];
};
var getHelpCenterLink = (helpCenter, countryCodeOrEmployer, groupBaseURL, source = "Enrollment") => {
  const language = getAppSupportedLocale(DEFAULT_LOCALE2, supportedLocaleList);
  return `${groupBaseURL}/${helpCenter == null ? void 0 : helpCenter[countryCodeOrEmployer]}?language=${getLanguageCode(language)}&utm_source=${source}`;
};
var HEALTH_PROGRAMS_AND_JOURNEY_LEARN_MORE_LINK = {
  CA: "s/topic/0TO4t00000000iwGAA/health-programs-and-journey",
  US: "s/topic/0TO4t00000000hNGAQ/health-programs-and-journey",
  KPMG: "s/topic/0TO4t00000000iMGAQ/health-programs-and-journey"
};
var CONTRIBUTION_ARTICLE_LINK_BY_PRODUCT_TYPES = {
  [PRODUCT_TYPES.HEALTH_SAVINGS_ACCOUNT]: "s/article/What-is-a-Health-Savings-Account-HSA-and-how-do-I-use-it",
  [PRODUCT_TYPES.FLEXIBLE_SPENDING_ACCOUNT]: "s/article/What-is-a-Flexible-Spending-Account-FSA-and-how-do-I-use-it",
  [PRODUCT_TYPES.HFSA]: "s/article/What-is-a-Flexible-Spending-Account-FSA-and-how-do-I-use-it",
  [PRODUCT_TYPES.DCFSA]: "s/article/What-is-a-Dependent-Care-Flexible-Spending-Account-DCFSA-and-how-do-I-use-it",
  [PRODUCT_TYPES.LPFSA]: "s/article/What-is-a-Limited-Purpose-Flexible-Spending-Account-LPFSA",
  [PRODUCT_TYPES.CRA]: "s/article/What-is-a-Commuter-Reimbursement-Account-CRA-and-how-do-I-use-it"
};
var GETTING_STARTED_WITH_LEAGUE_LINK = {
  CA: "s/article/Getting-started-on-League-1570651075769",
  US: "s/article/Getting-Started-on-League",
  KPMG: "s/article/360001355123"
};
var WHAT_ARE_CONNECTED_HEALTH_PROGRAMS_LINK = {
  CA: "s/article/What-are-Connected-Health-Programs",
  US: "s/article/What-are-Connected-Health-Programs-US",
  KPMG: "s/article/What-are-Connected-Health-Programs-KPMG"
};
var WHAT_DEVICES_CAN_CONNECT_LINK = {
  CA: "s/article/What-wearable-apps-and-devices-can-I-connect-to-my-League-account",
  US: "s/article/What-wearable-apps-and-devices-can-I-connect-to-my-League-account-US",
  KPMG: "s/article/What-wearable-apps-and-devices-can-I-connect-to-my-League-account-KPMG"
};
var HEALTH_PROGRAMS_MANUAL_TRACKING_LINK = {
  CA: "s/article/Do-I-have-to-connect-a-wearable-app-or-device-to-participate-in-Health-Programs",
  US: "s/article/Do-I-have-to-connect-a-wearable-app-or-device-to-participate-in-Health-Programs-US",
  KPMG: "s/article/Do-I-have-to-connect-a-wearable-app-or-device-to-participate-in-Health-Programs-KPMG"
};

// src/common/hooks/use-focus-first-formik-error/use-focus-first-formik-error.hook.ts
import { useEffect as useEffect13 } from "react";
import { useFormikContext } from "formik";
import flatten from "flat";
var INPUT_ELEMENT_TAG_NAMES = ["input", "select", "textarea"];
var isFocusableInputElement = (element) => INPUT_ELEMENT_TAG_NAMES.includes(element.tagName.toLowerCase());
var getClosestFocusableInputElement = (element) => element.querySelector(INPUT_ELEMENT_TAG_NAMES.join(","));
var useFocusFirstFormikError = (focusDelay = 250) => {
  const { isSubmitting, isValidating, errors } = useFormikContext();
  useEffect13(() => {
    if (isSubmitting && !isValidating) {
      const invalidFieldNames = Object.keys(flatten(errors));
      if (!invalidFieldNames.length) {
        return;
      }
      const selector = invalidFieldNames.map((fieldName) => `[name="${fieldName}"]`).join(",");
      const firstInvalidField = document.querySelector(selector);
      if (!firstInvalidField) {
        return;
      }
      const focusableElement = isFocusableInputElement(firstInvalidField) ? firstInvalidField : getClosestFocusableInputElement(firstInvalidField);
      if (focusableElement) {
        setTimeout(() => {
          focusableElement.focus();
        }, focusDelay);
      }
    }
  }, [isSubmitting, isValidating, errors, focusDelay]);
};

// src/common/hooks/use-prevent-scroll/use-prevent-scroll.hook.ts
import { useEffect as useEffect14 } from "react";
var usePreventScroll = (isEnabled) => {
  useEffect14(() => {
    if (isEnabled) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isEnabled]);
};
export {
  ADMIN,
  ALBERTA,
  ALLOCATION_OPTIONS,
  ANALYTICS,
  APPROVED,
  ASCENDING,
  BENEFICIARY,
  BENEFICIARY_FORM,
  BRITISH_COLUMBIA,
  CANADA,
  CANCELLED,
  CLAIMS_AGENT,
  CLAIM_STATUS_TRANSLATIONS,
  CLAIM_STATUS_TYPE_FILTER_MAP,
  CONSUMER,
  COUNTRY_OPTIONS,
  COUNTRY_TO_PROVINCE,
  CURRENCY_SYMBOLS,
  CURRENCY_TYPES,
  ControlledFieldset,
  ControlledFormField,
  DATEPICKER_DATE_FORMAT,
  DATE_FORMAT,
  DAYFORCE_DRIVER,
  DEFAULT_TIME_ZONE,
  DEPENDENT_RELATIONSHIP_MAP,
  DEPENDENT_VERIFICATION,
  DESCENDING,
  DOCUMENT_TYPES,
  EMPLOYEE_STATE_MAP,
  EMPLOYEE_STATE_NAMES,
  EMPLOYER_STATUSES,
  EMPLOYER_STATUS_TYPE_MAP,
  ENROLLMENT_TYPES,
  ENROLLMENT_TYPE_ACTIVATION,
  ENROLLMENT_TYPE_ANNUAL,
  ENROLLMENT_TYPE_BCC,
  ENROLLMENT_TYPE_NEW_HIRE,
  ENROLLMENT_TYPE_QLE,
  EOI,
  EVIDENCE_OF_INSURABILITY,
  FRONTEND_CLAIM_STATUS_TYPES,
  FormProvider,
  GETTING_STARTED_WITH_LEAGUE_LINK,
  GROUP_TYPES,
  HEALTH_ADMIN,
  HEALTH_PROGRAMS_AND_JOURNEY_LEARN_MORE_LINK,
  HEALTH_PROGRAMS_MANUAL_TRACKING_LINK,
  HR_ADMIN,
  HashLink,
  HtmlToReact,
  IDENTIFICATION,
  IRELAND,
  KEY,
  LONG_MONTH_FORMAT,
  LONG_WEEKDAY,
  LONG_WEEKDAY_DATE_FORMAT,
  MANITOBA,
  MODAL_DESCRIPTION,
  MODAL_TITLE,
  MONTH_YEAR,
  MORE_INFORMATION_NEEDED,
  ModalPortal,
  NEWFOUNDLAND_LABRADOR,
  NEW_BRUNSWICK,
  NEW_HR_ADMIN_LINK,
  NORTHWEST_TERRITORIES,
  NOT_APPLICABLE_HSA_ONLY,
  NOVA_SCOTIA,
  NUMERIC_YEAR_MONTH_DAY,
  NUNAVUT,
  OLD_HR_ADMIN_LINK,
  ONTARIO,
  OTHER,
  PAID,
  PENDING_EXTERNAL_REVIEW,
  PILL_RADIUS,
  PLAN_ENROLLMENT_STATUSES,
  PLAN_STATUSES,
  PORTAL_NODE_IDS,
  PREAPPROVAL_MORE_INFORMATION_NEEDED,
  PREAPPROVAL_REJECTED,
  PREAPPROVED,
  PRINCE_EDWARD_ISLAND,
  PROVINCES,
  PROVINCE_CODES,
  PROVINCE_STATE_OPTIONS,
  QUEBEC,
  REJECTED,
  RESET,
  ROLLOVER_OPTIONS,
  ROOT_NODE_ID,
  FormProvider2 as ReactHookFormProvider,
  SASKATCHEWAN,
  SHORT_DATE_AND_TIME_FORMAT,
  SHORT_DATE_AND_TIME_FORMAT_NO_TIMEZONE,
  SHORT_DATE_FORMAT,
  SHORT_MONTH_FORMAT,
  SHORT_MONTH_YEAR,
  SHORT_WEEKDAY_DATE_FORMAT,
  SHORT_WEEKDAY_FORMAT,
  STARTED,
  STATES,
  SUBMITTED,
  SUBMITTED_FOR_PREAPPROVAL,
  SUPER_ADMIN,
  SWIPE_DIRECTION,
  SWIPE_ORIENTATION,
  ServiceError,
  TAXES_BY_PROVINCE,
  TAX_TYPES,
  TENANT_ID,
  TYPING_DEBOUNCE_INTERVAL,
  UNICODE_DATE_FORMAT,
  UNITED_STATES,
  UPDATE,
  US,
  UTC,
  VIEW_ALL,
  WAITING_PERIOD_OPTIONS,
  WHAT_ARE_CONNECTED_HEALTH_PROGRAMS_LINK,
  WHAT_DEVICES_CAN_CONNECT_LINK,
  YUKON,
  YUKON_TERRITORIES,
  arrayToTag,
  camelToSnakeCase,
  createLifecycleTypes,
  currencyChecker,
  currencyPropType,
  defaultFlexDollarTerm,
  defaultFlexDollarTermId,
  defaultHTMLTagOptions,
  downloadBlobAsFile,
  easeOutCubic,
  fileReader,
  formatCurrency,
  formatPhoneNumber,
  formatPhoneNumberForHref,
  getActiveBusinessProfileGroup,
  getActiveEmployerGroup,
  getActiveGroup,
  getCityTranslationId,
  getContentfulImageUrl,
  getCurrencyForCountry,
  getHelpCenterLink,
  getHelpDeskLink,
  getOptionId,
  getParameterByName,
  getPostalCodeTranslationId,
  getProvinceTranslationId,
  getSentenceCasePostalCodeTranslationId,
  getSymbolForCurrency,
  getTypeformUrl,
  invertMap,
  isAbsoluteUrl,
  isAlphanumeric,
  isDateWithinRange,
  isEmail,
  isEntityId,
  isExternalUrl,
  isImageContentType,
  isKPMG,
  isMobile,
  isNumeric,
  isPhoneNumber,
  isQuebec,
  isValidUrl,
  lowercaseAndHypen,
  mockPose,
  mockResizeObserver,
  normalizeInternalUrl,
  normalizePolicyKind,
  normalizeUrl,
  omitKeysWithEmptyValues,
  openInTab,
  parseQuery,
  parseUrl,
  provinceStateShortToLong,
  reactQueryDecorator,
  splitAtNewlines,
  toTimeZoneString,
  transformAnchorTag,
  truncateWithEllipses,
  unescapeUnicode,
  uppercaseAndUnderscore,
  useAnalyticsIdentify,
  useCheckboxConfirm,
  useConfirm,
  useControlledInput,
  useController2 as useController,
  useDebounce,
  useDocumentTitle,
  useFlexDollarText,
  useFocusFirstFormikError,
  useForm2 as useForm,
  useFormContext3 as useFormContext,
  useFormState,
  useFormatDateByUserProfileLocation,
  useGetUserProfile,
  useHandleDropdown,
  useInput,
  useLeftoverFlexBenefitText,
  useListItemsFocusHook,
  useMultipleBenefitsText,
  useOnEscape,
  useOnlineStatus,
  useOutsideClick,
  usePrefersReducedMotion,
  usePreventScroll,
  useScrollTopOnLocationChange,
  useSwipeGestures,
  useTabFocus,
  useUrlParam,
  useWatch
};
//# sourceMappingURL=index.js.map